import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { MdOutlineLightMode, MdOutlineDarkMode } from "react-icons/md";

// Sayfaları doğrudan import ediyoruz (Formların kaybolmasını ENGELLER)
import Login from "../../views/auth/Login";
import FastLogin from "../../views/auth/FastLogin";
import Register from "../../views/auth/Register";

// Senin düzenlediğin footer
import Footer from "../../components/footer/FooterAuthDefault";

export default function Auth() {
  // --- Dark/Light Mode Kontrolü ---
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Sayfa ilk açıldığında HTML etiketinde 'dark' var mı kontrol et
    if (document.documentElement.classList.contains("dark")) {
      setIsDark(true);
    }
  }, []);

  const toggleTheme = () => {
    if (isDark) {
      document.documentElement.classList.remove("dark");
      setIsDark(false);
    } else {
      document.documentElement.classList.add("dark");
      setIsDark(true);
    }
  };

  return (
      <div className="relative flex min-h-screen w-full flex-col bg-gray-50 transition-colors duration-300 dark:bg-navy-900">

        {/* --- DARK/LIGHT MODE BUTONU (Sağ Üstte Yüzen Buton) --- */}
        <div className="absolute top-6 right-6 z-50">
          <button
              onClick={toggleTheme}
              className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-gray-600 shadow-md transition-all hover:bg-gray-100 hover:shadow-lg dark:bg-navy-800 dark:text-white dark:hover:bg-navy-700"
          >
            {isDark ? (
                <MdOutlineLightMode className="h-6 w-6 text-brand-400" />
            ) : (
                <MdOutlineDarkMode className="h-6 w-6 text-brand-500" />
            )}
          </button>
        </div>

        {/* --- ANA İÇERİK ALANI (Tam Ortalanmış SaaS Tasarımı) --- */}
        <main className="flex flex-grow items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
          {/* Ortadaki Form Kapsayıcısı */}
          <div className="w-full max-w-[450px]">

            {/* FORM KAYBOLMA SORUNUNA KESİN ÇÖZÜM
            routes.js'den map etmek yerine React Router v6'ya doğrudan yolları verdik.
          */}
            <Routes>
              <Route path="sign-in" element={<Login />} />
              <Route path="fast-login" element={<FastLogin />} />
              <Route path="register" element={<Register />} />

              {/* Hiçbirine uymazsa sign-in'e at */}
              <Route path="*" element={<Navigate to="sign-in" replace />} />
            </Routes>

          </div>
        </main>

        {/* --- ALT BİLGİ (Footer) --- */}
        <div className="mt-auto w-full border-t border-gray-200 bg-white py-4 dark:border-white/10 dark:bg-navy-900">
          <Footer />
        </div>

      </div>
  );
}